/** Human-readable labels for raw model/API codes. */

const TYPE_LABELS = {
  equity: 'Equity',
  fixed_income: 'Fixed Income',
  derivative: 'Derivative',
  commodity: 'Commodity',
  forex: 'Forex',
  crypto: 'Cryptocurrency',
  etf: 'ETF',
  fund: 'Fund',
  stock: 'Stock',
  bond: 'Bond',
};

const DEALING_LABELS = {
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  semi_annual: 'Semi-annual',
  annual: 'Annual',
  ad_hoc: 'Ad hoc',
};

export function humanizeCode(value) {
  if (value == null || value === '') return '—';
  const key = String(value).trim().toLowerCase();
  if (TYPE_LABELS[key]) return TYPE_LABELS[key];
  if (DEALING_LABELS[key]) return DEALING_LABELS[key];
  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatMoney(value, { fractionDigits = 2 } = {}) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatUnits(value, { fractionDigits = 4 } = {}) {
  return formatMoney(value, { fractionDigits });
}
